import {
  calculateNaviExplorerBookingPricing,
  calculateNaviPartnerPricing,
  calculateReverseMeetupPricing,
  fetchHqNaviPricing,
  getIslandTaxRate,
  NAVI_PROFIT_DEFAULTS,
} from "./naviProfitModel";

export { getIslandTaxRate, NAVI_PROFIT_DEFAULTS };

export {
  calculateReverseMeetupPricing,
  calculateNaviPartnerPricing,
  calculateNaviExplorerBookingPricing,
  fetchHqNaviPricing,
};

export function calculateMeetupPricing({
  basePrice = 75,
  guests = 2,
  country = "barbados",
  partnerTier = "standard",
} = {}) {
  const cleanGuests = Math.max(Number(guests) || 1, 1);
  const payoutTotal = (Number(basePrice) || 0) * cleanGuests;
  const reverse = calculateNaviPartnerPricing({
    desiredPayout: payoutTotal,
    country,
    partnerTier,
  });

  return {
    subtotal: reverse.taxableSubtotal,
    taxRate: reverse.taxRate,
    vatCollected: reverse.vatCollected,
    mansionFee: reverse.dhcPlatformFee,
    dhcFee: reverse.dhcPlatformFee,
    bookingServiceFee: reverse.bookingServiceFee,
    paymentProcessingRecovery: reverse.paymentProcessingRecovery,
    dhcGrossRevenue: reverse.dhcGrossRevenue,
    totalPrice: reverse.totalPrice,
    customerPays: reverse.totalPrice,
    businessPayout: reverse.businessPayout,
    guests: cleanGuests,
  };
}

export function formatMoney(amount, currency = "USD") {
  return new Intl.NumberFormat("en-BB", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount) || 0);
}
